import { CSSObject } from '@chakra-ui/react';

export const GreenIDContainer: CSSObject = {
  py: ['4', null, '10'],
  px: ['2', null, '10'],
  maxW: ['100vw', null, '500px'],
  bg: 'alpha.600',
  'button#greenid-option-list-toggle': {
    borderRadius: 'md',
    bg: 'blackAlpha.400',
    color: 'white',
    border: 'none',
    boxShadow:
      '0px 1px 5px 0px rgba(0, 0, 0, 0.15) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.10)',
  },
  '#greenid-source-header #greenid-source-title': {
    '#greenid-source-help': {
      '&[aria-hidden="false"]': {
        position: 'fixed',
        display: 'flex !important',
        m: 'auto',
        alignItems: 'center',
      },
    },
    '#greenid-source-title-heading': {
      color: 'white',
      fontWeight: 'medium',
      fontSize: 'sm',
      fontFamily: 'roboto',
    },
    'a.greenid-modal-launch': {
      textDecor: 'none',
      '.glyphicon-question-sign': {
        color: 'gamma.600',
      },
    },
  },
  '#greenid-intro-words': {
    '.lead': {
      color: 'white',
      fontSize: 'xs',
      fontFamily: 'roboto',
      fontWeight: 'normal',
    },
  },
  '#greenid-intro-content': {
    h1: {
      color: 'white',
      fontSize: 'md',
      fontFamily: 'roboto',
      fontStyle: 'normal',
      fontWeight: 'normal',
      textTransform: 'uppercase',
      mb: '4',
      gap: '5px',
      mt: 0,
    },
    p: {
      color: 'white',
      fontWeight: 'normal',
      fontSize: 'sm',
      fontFamily: 'roboto',
    },
  },
  '&&': {
    '#greenid-container': {
      bg: 'unset',
      a: {
        color: 'white',
      },
      '.greenid-helpicon': {
        color: '#FF9F1C',
      },
      '#greenid-source-header': {
        display: 'flex',
        flexDirection: 'column',
      },
      '#greenid-source-content': {
        borderTop: '1px solid',
        boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.07) inset',
        borderTopColor: 'blackAlpha.500',
        '#greenid-source-body': {
          p: {
            color: 'white',
            strong: {
              color: 'white',
            },
          },
          '.checkbox.greenid-has-error': {
            '.help-block': {
              bg: 'gray.900',
              color: 'gray.200',
              boxShadow:
                '0px 2px 4px 0px rgba(0, 0, 0, 0.2), 0px 1px 0px 0px rgba(255, 255, 255, 0.1) inset',
              borderRadius: '3px',
              fontWeight: 'medium',
              py: '0.5',
              px: '1.5',
              mr: '1',
              mt: '1',
            },
          },
          '.row': {
            '.greenid-has-error': {
              '.help-block': {
                bg: 'gray.900',
                color: 'gray.200',
                boxShadow:
                  '0px 2px 4px 0px rgba(0, 0, 0, 0.2), 0px 1px 0px 0px rgba(255, 255, 255, 0.1) inset',
                borderRadius: '3px',
                fontWeight: 'medium',
                py: '0.5',
                px: '1.5',
                mr: '1',
                mt: '1',
              },
            },
            '.form-group': {
              select: {
                borderRadius: 'md',
                bg: 'white',
                color: 'black',
                border: 'none',
                boxShadow:
                  '0px 1px 5px 0px rgba(0, 0, 0, 0.15) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.10)',
                option: {
                  color: 'black',
                },
              },
              '.control-label': {
                color: 'white',
              },
              'label[for="greenid-bdm-stateselect"]': {
                color: 'white',
              },
              label: {
                color: 'black',
                fontWeight: 'medium',
                fontSize: 'sm',
                fontFamily: 'roboto',
                'span, span.help-block': {
                  color: 'white',
                  fontWeight: 'medium',
                  fontSize: 'sm',
                  fontFamily: 'roboto',
                  bg: 'transparent',
                  boxShadow: 'none',
                },
              },
              'input[type="text"]': {
                borderLeftRadius: 'md',
                bg: 'blackAlpha.400',
                boxShadow:
                  '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 1px 5px 0px rgba(0, 0, 0, 0.15) inset',
                border: 'none',
                color: 'white',
                fontWeight: 'normal',
                '&&:hover, &&:focus': {
                  bg: 'blackAlpha.400',
                },
                _placeholder: {
                  color: 'white',
                },
                h: '38px',
              },
            },
          },
          '.checkbox': {
            'input[type="checkbox"]': {
              width: '20px',
              height: '20px',
              bg: 'alpha.400',
              borderWidth: '2px',
              borderColor: 'gray.200',
              marginLeft: '-28px',
              borderRadius: 'sm',

              '&[data-checked]': {
                width: '20px',
                height: '20px',
                bg: 'alpha.400',
                borderColor: 'alpha.400',
              },
              '&[data-checked]:hover': {
                width: '20px',
                height: '20px',
                bg: 'alpha.400',
                borderColor: 'alpha.400',
              },
            },
            label: {
              fontSize: 'xs',
              color: 'white',
              paddingLeft: '28px',
            },
          },
        },
      },
      '.input-group-addon': {
        bg: 'rgba(0, 0, 0, 0.24)',
        border: 'none',
        boxShadow:
          '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 1px 5px 0px rgba(0, 0, 0, 0.15) inset',
        '.glyphicon-calendar': {
          color: 'gamma.600',
        },
      },
    },
  },
  '#greenid-submit-button-container': {
    button: {
      borderRadius: 'md',
      bgGradient: 'linear(to-b, gamma.500 0%, gamma.600 100%)',
      boxShadow:
        '0px 0px 0px 2px rgba(255, 192, 51, 1) inset, 0px 0px 0px 3px rgba(117, 20, 16, 1) inset, 0px 0px 0px 4px rgba(255, 255, 255, 0.6) inset, 0px 6px 10px 0px rgba(0, 0, 0, 0.2)',
      color: 'blackAlpha.700',
      fontFamily: 'accentStaat',
      fontSize: 'sm',
      textTransform: 'capitalize',
      textShadow: '0px 1px 0px rgba(255, 255, 255, 0.35)',
      _hover: {
        bgGradient: 'linear(to-b, gamma.300 0%, gamma.300 100%)',
        bg: 'gamma.300',
        boxShadow:
          '0px 0px 0px 2px rgba(255, 192, 51, 1) inset, 0px 0px 0px 3px rgba(117, 20, 16, 1) inset, 0px 0px 0px 4px rgba(255, 255, 255, 0.6) inset, 0px 6px 10px 0px rgba(0, 0, 0, 0.2)',
        color: 'blackAlpha.700',
        textShadow: '0px 1px 0px rgba(255, 255, 255, 0.35)',
      },
      ':active, &[data-active="true"]': {
        bg: 'blackAlpha.500',
        boxShadow:
          '0px 1px 0px 0px rgba(255, 255, 255, 0.08), 0px 2px 0px 0px rgba(0, 0, 0, 0.3) inset',
        color: 'gamma.500',
        textShadow: 'none',
      },
      _disabled: {
        opacity: 0.4,
        pointerEvents: 'none',
        bgGradient: 'linear(180deg, gamma.500 0%, gamma.600 100%)',
        boxShadow:
          '0px 0px 0px 2px rgba(255, 192, 51, 1) inset, 0px 0px 0px 3px rgba(117, 20, 16, 1) inset, 0px 0px 0px 4px rgba(255, 255, 255, 0.6) inset, 0px 6px 10px 0px rgba(0, 0, 0, 0.2)',
      },

      '&&&': {
        '& > svg, & > span': { zIndex: 9 },
      },
    },
  },
};
